import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import CalculatorHome from "./views/CalculatorHome.vue";
import LifeResult from "./views/LifeResult.vue";
import LifeExpress from "./views/LifeExpress.vue";
import LifeDetailed from "./views/LifeDetailed.vue";
import IncomeResult from "./views/IncomeResult.vue";
import IncomeExpress from "./views/IncomeExpress.vue";
import IncomeDetailed from "./views/IncomeDetailed.vue";


Vue.use(Router);

export default new Router({
    base: '/calculator',
    mode: 'history',
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/life",
            name: "LifeCalculatorHome",
            props: {
                title: "Life Insurance Calculator",
                subHeading: "Our Life Insurance calculator can help you estimate the coverage amount that may be right for you and your loved ones.",
                introCopy: `
                    <p>At Suncorp Life, we believe in preparing for the future. That's why we offer life insurance policies that provide peace of mind to you and your loved ones. Our coverage options are designed to meet your specific circumstances and lifestyle.</p>
                `
            },
            component: CalculatorHome
        },
        {
            path: "/life/express/results",
            name: "ExpressLifeResults",
            component: LifeResult
        },
        {
            path: "/life/detailed/results",
            name: "DetailedLifeResults",
            component: LifeResult
        },
        {
            path: "/life/express/",
            name: "LifeExpress",
            component: LifeExpress
        },
        {
            path: "/life/detailed/",
            name: "LifeDetailed",
            component: LifeDetailed
        },
        {
            path: "/income",
            name: "IncomeCalculatorHome",
            props: {
                title: "Income Protection Insurance Calculator",
                subHeading: "Get a personalised coverage estimate and learn about Suncorp's Income protection Insurance options. Protect yourself and your loved ones with confidence.",
                introCopy: `
                    <p>At Suncorp Life, we know that planning for the unexpected is an essential part of life. That's why we offer Income Protection Insurance designed to provide peace of mind to you and your family. Whether you're single, starting a family, buying a home, Suncorp’s Income protection Insurance is tailored to meet your individual needs.</p>
                `
            },
            component: CalculatorHome
        },
        {
            path: "/income/express/results",
            name: "ExpressIncomeResults",
            component: IncomeResult
        },
        {
            path: "/income/detailed/results",
            name: "DetailedIncomeResults",
            component: IncomeResult
        },
        {
            path: "/income/express/",
            name: "IncomeExpress",
            component: IncomeExpress
        },
        {
            path: "/income/detailed/",
            name: "IncomeDetailed",
            component: IncomeDetailed
        }
    ]
});
